import { trace } from "owa-trace";

const metrics = {
    global: {
        initialLoadTime: -1,
        initialMemoryOnLoad: -1,
        memoryWhenVisible: {
            totalMemoryUsed: 0,
            numberOfSamples: 0,
            average: -1,
        },
        memoryWhenHidden: {
            totalMemoryUsed: 0,
            numberOfSamples: 0,
            average: -1,
        },
    },
    copilot: {
        initialLoadTime: -1,
        initialMemoryOnLoad: -1,
        memoryWhenVisible: {
            totalMemoryUsed: 0,
            numberOfSamples: 0,
            average: -1,
        },
        memoryWhenHidden: {
            totalMemoryUsed: 0,
            numberOfSamples: 0,
            average: -1,
        },
    },
};

export function getIframeMetrics(): typeof metrics {
    return metrics;
}

export function addIframeMetric(type: "global" | "copilot", state: "Visible" | "Hidden", memory: number): void {
    if (memory !== -1) {
        const metric = metrics[type][`memoryWhen${state}`];
        
        metric.totalMemoryUsed += memory;
        metric.numberOfSamples += 1;
        metric.average = Math.floor(metric.totalMemoryUsed / metric.numberOfSamples);
        
        trace.info(`[IframeMetrics] Updated ${type} iframe metrics for ${state} state: ${JSON.stringify(metric)}`, "iframeWrapper");
    }
}

export function addIframeOnLoadMetric(type: "global" | "copilot", memory: number, initialLoadTime: number): void {
    const metric = metrics[type];
    
    if (metric.initialMemoryOnLoad === -1) {
        metric.initialMemoryOnLoad = memory;
    }
    
    if (metric.initialLoadTime === -1) {
        metric.initialLoadTime = initialLoadTime;
    }
    
    trace.info(`[IframeMetrics] Add ${type} iframe metrics for onload state: ${JSON.stringify(metric)}`, "iframeWrapper");
}
